module.exports = __webpack_public_path__ + "static/media/CSU.7d1466ad.png";